export class TechItem {
	constructor(image, descr = null, width = null, height = null) {
		this.image = image;
		this.descr = descr;
		this.width = width !== null ? width : 12;
		this.height = height !== null ? height : 5;
	}
}